import { useEffect, useRef, useState } from "react";
import MainPageTemplate from "./MainPageTemplate";
import "../Assets/scss/template/useractiontemplate.scss";
import DashboardLanguageButton from "../Components/LanguageButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import Slider1 from "../Assets/img/Login-1.webp";
import Slider2 from "../Assets/img/Login-2.webp";
import Slider3 from "../Assets/img/Login-3.webp";
import Slider4 from "../Assets/img/Login-4.webp";
import Slider5 from "../Assets/img/Login-5.webp";

// Import your new, simplified ProgressiveImage component
import ProgressiveImage from "./ProgressiveImage";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../PropTypes/StoreProptypes";

// sliderData is now simpler, without placeholders
const sliderData = [
  { id: 1, img: Slider1, alt: "Accessibility Dashboard 1" },
  { id: 2, img: Slider2, alt: "Accessibility Dashboard 2" },
  { id: 3, img: Slider3, alt: "Accessibility Dashboard 3" },
  { id: 4, img: Slider4, alt: "Accessibility Dashboard 4" },
  { id: 5, img: Slider5, alt: "Accessibility Dashboard 5" },
];

interface PropTypes {
  children: any;
}

const UserActionPagesTemplate = ({ children }: PropTypes) => {
  const swiperRef = useRef<any>(null);
    // Redux data
    const {
      activeLanguage,
      translationLoading
    } = useSelector((store: StoreProptypes) => store);
    console.log('isLoading: ', translationLoading);

  useEffect(() => {
    let resizeTimer: NodeJS.Timeout;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (swiperRef.current?.swiper?.autoplay) {
          swiperRef.current.swiper.autoplay.start();
        }
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const swiperInstance = swiperRef.current?.swiper; // access actual Swiper instance
    if (swiperInstance && activeLanguage) {
      swiperInstance.changeDirection(activeLanguage.is_rtl ? "rtl" : "ltr");
      swiperInstance.update();
      console.log("Swiper direction updated:", activeLanguage.is_rtl ? "rtl" : "ltr");
    }
  }, [activeLanguage])

  const handleMouseEnter = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.autoplay.start();
    }
  };

  return (
    <MainPageTemplate>
      <div className="aioa_dashboard-content-wrapper">
        <main id="main">
          <div className="aioa_dashboard-user-module-wrapper">
            <div className="aioa_dashboard-user-module-inner-wrapper">
              <div className="aioa_dashboard-user-module-form">{children}</div>
              <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className="aioa_dashboard-user-module-video group"
              >
                <div className={`aioa_dashboard-header-user-wrapper d-flex justify-content-end position-absolute top-0 ${activeLanguage?.is_rtl ? 'start-0' : 'end-0'} z-3 m-5 me-5`}>
                  <DashboardLanguageButton />
                </div>
                {!translationLoading && (

                <Swiper
                  key={activeLanguage?.code} // <— changing key forces re-init
                  ref={swiperRef}
                  modules={[Autoplay]}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  loop
                  observer={true}
                  observeParents={true}
                  speed={800}
                  dir={activeLanguage?.is_rtl ? "rtl" : "ltr"}
                >
                  {sliderData.map((slide) => (
                    <SwiperSlide key={slide.id}>
                      {/* Use the simplified ProgressiveImage component */}
                      <ProgressiveImage
                        src={slide.img}
                        alt={slide.alt}
                        loading="eager"
                        style={{
                          width: "96%",
                          height: "96%",
                        }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </MainPageTemplate>
  );
};

export default UserActionPagesTemplate;